// extracted by mini-css-extract-plugin
export default {"filmView":"FilmDetails_filmView__8AB1l"};